<template>
  <div class="app-wrap" aria-hidden="true">
    <div class="caret"></div>
    <img v-if="appOn" class="toolbar" src="./images/toolbar-on.png" alt="">
    <img v-else class="toolbar" src="./images/toolbar-off.png" alt="">
    <img class="arm" :class="{'point': point}" src="./images/pointing-arm.png" alt="">
    <div id="app" :class="{'on': appOn}">
      <div class="app-top">
        <div class="toggle">
          <div class="slider" :class="{'glow': point, 'shake': shakeSlider}" @click="toggle()">
            <div class="slider-button"></div>
          </div>
        </div>
        <div class="copy">
          <p class="connection">
            <template v-if="appOn">
              <span v-if="animating">Connecting...</span>
              <span v-else>Connected</span>
            </template>
            <template v-else>
              <span v-if="animating">Disconnecting...</span>
              <span v-else>Disconnected</span>
            </template>
          </p>
          <div class="location-select">
            <p class="country">Fastest</p>
            <div class="dropdown"></div>
          </div>
          <div class="settings"></div>
        </div>
      </div>
      <div class="map-frame">
        <div id="map">
          <div class="line-holder">
            <div class="line"></div>
          </div>
          <img class="map-img" srcset="./images/demo-map@2x.png 2x, ./images/demo-map.png 1x" src="./images/demo-map@2x.png" alt="">
          <img class="bear-hole" :src="holeSrc" alt="">
          <div v-for="location in locations" v-bind:key="location.id">
            <div class="location" :class="location.id">
              <img class="tunnel" src="./images/tunnel.png" alt="">
              <p class="tunnel-location">{{location.name}}</p>
            </div>
          </div>
          <div class="location uk">
            <img class="tunnel" :src="tunnelSrc" alt="">
            <p class="tunnel-location">United Kingdom</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/services/services.js'
import is from 'is_js'
import locations from './data/locations.json'

export default {
  name: 'app-demo',
  data () {
    return {
      locations: locations,
      appOn: false,
      point: false,
      shakeSlider: false,
      holeSrc: require('./images/bear/bearpin2_06@2x.png'),
      holeImgs: [],
      holeIndex: 6,
      tunnelSrc: require('./images/bear/bear_tunnel_animation_00@2x.png'),
      tunnelIndex: 0,
      tunnelImgs: [],
      animating: false
    }
  },
  mounted: function () {
    this.preloadImgs()

    setTimeout(() => {
      if (!this.appOn) {
        this.point = true
      }
    }, 3000)
    setTimeout(() => {
      if (this.point) {
        this.shakeSlider = true
      }
    }, 7000)
  },
  methods: {
    toggle: function () {
      if (this.animating) return
      if (!this.appOn) { // turning on
        this.animateHole('backward')
        this.appOn = true
        this.animating = true
        this.point = false
        setTimeout(() => {
          this.animateTunnel('forward')
        }, 2500)
      } else { // turning off
        if (is.edge()) return // tunnel positions go funky on disconnect in MS Edge
        this.appOn = false
        this.animateTunnel('backward')
        this.animating = true
        setTimeout(() => {
          this.animateHole('forward')
        }, 2700)
      }
      setTimeout(() => {
        this.animating = false
      }, 3300)
    },
    animateHole: function (direction) {
      if (direction === 'forward') {
        if (this.holeIndex >= 4) return
        this.holeIndex++
      } else {
        if (this.holeIndex <= 0) return
        this.holeIndex--
      }
      setTimeout(() => {
        this.holeSrc = this.holeImgs[this.holeIndex][0].src
        this.animateHole(direction)
      }, 80)
    },
    animateTunnel: function (direction) {
      if (direction === 'forward') {
        if (this.tunnelIndex >= 5) return
        this.tunnelIndex++
      } else {
        if (this.tunnelIndex <= 0) return
        this.tunnelIndex--
      }
      setTimeout(() => {
        this.tunnelSrc = this.tunnelImgs[this.tunnelIndex][0].src
        this.animateTunnel(direction)
      }, 80)
    },
    preloadImgs: function () {
      for (let i = 0; i < 6; i++) {
        services.preloadImages([require(`./images/bear/bear_tunnel_animation_0${i}@2x.png`)]).then((img) => {
          this.tunnelImgs.push(img)
        })
        services.preloadImages([require(`./images/bear/bearpin2_0${i}@2x.png`)]).then((img) => {
          this.holeImgs.push(img)
        })
      }
    }
  }
}
</script>

<style scoped lang="stylus" src="./app-demo.styl" >



// WEBPACK FOOTER //
// src/components/app-demo/app-demo.vue